<template>
  <div id="app">
    <div class="container" style="overflow: hidden;">
      <web-header></web-header>
      <router-view/>
    <div v-show="$route.path=='/'">
      <web-ad></web-ad>
    </div>
    <web-foot></web-foot>
    </div>
  </div>
</template>
<script>
import WebHeader from '@/components/basic/WebHeader'
import WebFoot from '@/components/basic/WebFoot'
import WebAd from '@/components/basic/WebAd'
export default {
  components:{
    WebFoot,WebAd,WebHeader
  }
}
</script>

<style lang="scss">
#app{
  min-width:$width;
}
</style>
